<template>
  <div class="flex flex-col max-h-20 overflow-y-auto">
    <div class="p-2 rounded-md bg-gray-100">
      <span class="text-gray-300 uppercase">Items</span>
      <div class="flex flex-col p-2 text-sm max-h-40 overflow-y-auto rounded-md bg-white">
        <span
          v-for="item in items"
          :key="item">
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: undefined,
  }
}
</script>
